<mx-preloader preloaderName="report"></mx-preloader>

<mat-card>
    <div class="multiple-columns">
        <mat-card-content class="mx-form-fields">
            <div class="mx-dynamic-field">
                <mat-form-field class="mxs-input">
                    <mat-label>
                        <prl-label value="label.marketing.tools.products"/>
                    </mat-label>
                    <mat-select hideSingleSelectionIndicator="true"
                                [formControl]="productControl"
                                (selectionChange)="filterChanged($event)"
                                [compareWith]="compareById"
                                [multiple]="true">
                        @for (product of availableProducts; track product) {
                            <mat-option [value]="product">{{ product.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="mx-dynamic-field">
                <mat-form-field class="mxs-input">
                    <mat-label>
                        <prl-label value="label.marketing.tools.languages"/>
                    </mat-label>
                    <mat-select hideSingleSelectionIndicator="true"
                                [formControl]="languageControl"
                                (selectionChange)="filterChanged($event)"
                                [compareWith]="compareById"
                                [multiple]="true">
                        @for (language of availableLanguages; track language) {
                            <mat-option [value]="language">{{ language.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="mx-dynamic-field">
                <mat-form-field class="mxs-input">
                    <mat-label>
                        <prl-label value="label.marketing.tools.currencies"/>
                    </mat-label>
                    <mat-select hideSingleSelectionIndicator="false"
                                [formControl]="currencyControl"
                                (selectionChange)="filterChanged($event)"
                                [compareWith]="compareById"
                                [multiple]="true">
                        @for (currency of availableCurrencies; track currency) {
                            <mat-option [value]="currency">{{ currency.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="mx-dynamic-field">
                <mat-form-field class="mxs-input">
                    <mat-label>
                        <prl-label value="label.description"/>
                    </mat-label>
                    <input matInput [formControl]="descriptionControl">
                </mat-form-field>
            </div>
            @for (productType of allProductTypes; track productType) {
                <div class="mx-dynamic-field">
                    <mat-form-field class="mxs-input">
                        <mat-label>
                            <prl-label value="{{productType.name}}"/>
                        </mat-label>
                        <mat-select hideSingleSelectionIndicator="false"
                                    [formControl]='this.controlsMap.get(productType.id)'
                                    (selectionChange)="filterChanged($event)"
                                    [compareWith]="compareById"
                                    [multiple]="true">
                            @for (subtype of getAvailableSubtype(productType.id); track subtype) {
                                <mat-option [value]="subtype">{{ subtype.name }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            }
            <div class="mx-dynamic-field">
                <mat-form-field class="mxs-input">
                    <mat-label>
                        <prl-label value="label.marketing.tools.zone.creative"/>&nbsp;<prl-label value="label.marketing.tools.zone.description"/>
                    </mat-label>
                    <input matInput [formControl]="creativeDescriptionControl">
                </mat-form-field>
            </div>
        </mat-card-content>
        <mat-card-actions>
            <mx-button [buttonModel]="searchButton"></mx-button>
            <mx-button [buttonModel]="resetButton"></mx-button>
        </mat-card-actions>
    </div>
</mat-card>

<mat-card class="filters">
    <div class="row">
        <div class="sort-container">
            <mat-form-field class="mxs-input">
                <mat-label>
                    <prl-label value="label.marketing.tools.sort.by"/>
                </mat-label>
                <mat-select hideSingleSelectionIndicator="false"
                            [formControl]="sortControl"
                            (selectionChange)="selectSortOption($event)"
                            [compareWith]="compareById"
                            [multiple]="false"
                            required>
                    @for (option of sortOptions; track option) {
                        <mat-option [value]="option">{{ (option.name | mxTranslate)() }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mx-info-tooltip [config]="infoConfig"></mx-info-tooltip>
        </div>
        <div class="toggle-container">
            @if (!isMobile) {
                <prl-label value="label.marketing.tools.view"></prl-label>
                <mx-button [buttonModel]="listButton"></mx-button>
                <mx-button [buttonModel]="galleryButton"></mx-button>
            }
        </div>
    </div>
</mat-card>

<mat-card class="table">
    <prl-zones [zones]="filteredZones"
               [gridView]="selectedView">
    </prl-zones>
</mat-card>


